import type {Type} from '@packages/systems/wfdl';

import {isPopoverAction, type PopoverAction} from './actions';
import {isPopoverTarget, isPopoverTargetType} from './target';
import {getPopoverDomId} from './ids';
import {
  defineOverlayTargetContext,
  OverlayTargetContextType,
  type OverlayKindConfig,
  type OverlayTarget,
} from '../shared/targetContext';

export type PopoverTargetFactory = (action: unknown) => {
  mode: 'popover';
  popoverAction: PopoverAction;
  popoverTarget?: OverlayTarget;
};

export type PopoverTargetContext = (
  componentKey: string
) => (targetId: string) => PopoverTargetFactory;

const createPopoverTargetFactory =
  (popoverTarget?: OverlayTarget): PopoverTargetFactory =>
  (action) => {
    const popoverAction = isPopoverAction(action) ? action : 'toggle';
    return popoverTarget === undefined
      ? {mode: 'popover', popoverAction}
      : {mode: 'popover', popoverAction, popoverTarget};
  };

const popoverKindConfig: OverlayKindConfig<PopoverTargetFactory> = {
  isTarget: isPopoverTarget,
  isTargetType: isPopoverTargetType,
  getDomId: getPopoverDomId,
  createTargetFactory: createPopoverTargetFactory,
  fallbackTargetFactory: createPopoverTargetFactory(),
};

export const PopoverTargetContextType: Type = OverlayTargetContextType;

export const {
  buildContext: buildPopoverTargetContext,
  createContextRef: createPopoverTargetContextRef,
} = defineOverlayTargetContext(popoverKindConfig);
